/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  user-details-api.ts
 *
 * Project Title :  Checkout
 *
 * Description    :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Madhu Gali
 *
 * @Date        : Oct 10, 2019
 *
 * @Version      : Version 1.0
 *
* By            : Madhu Gali - H175591
* On            : Feb 19, 2020
* Description   : ASDS-2355
*
* By            : H422335
* On            : Oct 27, 2020
* Description   : ASDS-3269 Migration of backend URLs to Forge endpoints
 ******************************************************************************/
import API from './api';
import { CheckoutServiceURL } from '../constants/checkout-constants';
import { handleResponse, handleError } from './apiUtils';

class UserDetailsAPI {

    static async checkSFDCCaseStatus(userID: string): Promise<any> {
        const URL: string = `${CheckoutServiceURL.SFDC_CASE_STATUS_URL}/${userID}/addresses`;
        const data = await API.get(URL)
            .then(handleResponse)
            .catch(handleError);
        return data;
    }

    static async hasASDSAccess() {
        const URL: string = `${CheckoutServiceURL.HAS_ASDS_ACCESS}`;
        const data = await API.get(URL)
            .then(handleResponse)
            .catch(handleError);
        return data;
    }

    static async checkForUserRole() {
        const URL: string = `${CheckoutServiceURL.ASDS_USER_ROLE_URL}`;
        const data = await API.get(URL)
            .then(handleResponse)
            .catch(handleError);
        return data;
    }

}

export default UserDetailsAPI;